<app-page-stepper
    [verticalSteps]="false"
    [submitVisible]="false"
    [isLoading]="isLoading"
    (stepChange)="onStepChange($event)"
    (tryNext)="onTryNext()">
    <app-stepper [canContinue]="selectedLine && selectedToolRequest">
        <ng-template
            #title>{{ 'lineSetter.tool-returns.stepper.select-line-and-tool-request.title' | translate }}
        </ng-template>
        <ng-template #content let-step="step">
            <app-search-line-and-request
                [isLoading]="isLoading"
                (lineChanged)="onLineChanged($event)"
                (toolChanged)="onToolRequestChanged($event)"></app-search-line-and-request>
        </ng-template>
    </app-stepper>
    <app-stepper>
        <ng-template #title>{{ 'lineSetter.tool-returns.stepper.confirm.title' | translate }}</ng-template>
        <ng-template #content>
            <div class="tool-confirm-step">
                <div class="header">
                    <h2>{{ 'lineSetter.tool-returns.stepper.confirm.title' | translate }}</h2>
                </div>
                <div class="body">
                    <div *ngIf="currentStep == 2 && !toolsLoading; else loadingAnimation">
                        <div class="row"
                             *ngIf="toolsNeededAtLine.length === 0 &&
                                    toolsReservedAtLine.length === 0 &&
                                    toolsNeededToBeReturned.length === 0 &&
                                    toolsExcludedFromReturn.length === 0">
                            {{ 'lineSetter.tool-returns.no-tools' | translate }}
                        </div>
                        <div class="row" *ngIf="toolsNeededAtLine.length > 0">
                            <app-tool-scan-tree
                                [isMaterial]="false"
                                labelText="{{'lineSetter.tool-returns.stepper.confirm.panel.toolsTreeNeededAtLine' | translate }}"
                                [loading]="toolsLoading"
                                [items]="toolsNeededAtLine">
                            </app-tool-scan-tree>
                        </div>
                        <div class="row" *ngIf="toolsReservedAtLine.length > 0">
                            <div class="col s12">
                                <app-tool-scan-tree
                                    labelText="{{'lineSetter.tool-returns.stepper.confirm.panel.toolsTreeReservedAtLine' | translate }}"
                                    [loading]="toolsLoading"
                                    [items]="toolsReservedAtLine">
                                </app-tool-scan-tree>
                            </div>
                        </div>
                        <div class="row" *ngIf="toolsExcludedFromReturn.length > 0">
                            <app-tool-scan-tree
                                [isMaterial]="false"
                                [loading]="toolsLoading"
                                labelText="{{'lineSetter.tool-returns.stepper.confirm.panel.toolsTreeRemainingAtLine'  | translate }}"
                                [items]="toolsExcludedFromReturn">
                            </app-tool-scan-tree>
                        </div>

                        <div class="row" *ngIf="toolsNeededToBeReturned.length > 0">
                            <app-tool-scan-tree
                                [isMaterial]="false"
                                [loading]="toolsLoading"
                                labelText="{{'lineSetter.tool-returns.stepper.confirm.panel.toolsTreeNeededToBeReturned'| translate}}"
                                [items]="toolsNeededToBeReturned">
                            </app-tool-scan-tree>
                        </div>
                        <div class="row">
                            <app-alert
                                *ngIf="canPerformReturn()"
                                type="error"
                                message="{{'lineSetter.tool-returns.stepper.confirm.alert.toolsNeededAtLine' | translate }}"></app-alert>
                        </div>
                        <div class="row" *ngIf="hasNonReturnableTools">
                            <app-alert
                                type="error"
                                message="{{ 'lineSetter.tool-returns.stepper.confirm.alert.nonReturnableTools' | translate }}">
                            </app-alert>
                        </div>
                    </div>
                </div>
                <div class="footer" *ngIf="toolsNeededToBeReturned.length !== 0">
                    <app-icon-button
                        [disabled]="canPerformReturn()"
                        text="{{ 'generic.buttons.confirm' | translate }}"
                        variant="fa-check"
                        class="confirm-button"
                        [responsive]="true"
                        [inline]="true"
                        (click)="onConfirmClick()">
                    </app-icon-button>
                </div>
            </div>
        </ng-template>
    </app-stepper>
</app-page-stepper>
<app-confirmation-modal
    (confirmEvent)="onConfirmReasonReturn($event)"
    #successReasonModal
    title="{{ 'lineSetter.tool-returns.pages.reasonPopupTitle' | translate }}"
    [displayReasonPlaceholder]="'lineSetter.tool-returns.forms.returnReasonPlaceholder' | translate"
    [isConfirmationInProgress]="isConfirmationInProgress"
    [reasonMandatory]="true"
    [confirmWithReason]="true">
</app-confirmation-modal>
<app-confirmation-modal
    (confirmEvent)="onConfirmReturn()"
    #successModal
    title="{{ 'lineSetter.tool-returns.pages.popupTitle' | translate }}"
    question="{{ 'lineSetter.tool-returns.pages.popupQuestion' | translate }}"
    message="{{ 'lineSetter.tool-returns.pages.popupMessage' | translate }}"
    [isConfirmationInProgress]="isConfirmationInProgress"
    [confirmOnlyMode]="true">
</app-confirmation-modal>
<app-confirmation-modal
    #errorModal
    title="{{ 'lineSetter.toolRequest.pages.popupError' | translate }}"
    [message]="confirmationPopupMessage"
    [confirmOnlyMode]="true"
    [showConfirmButton]="false">
</app-confirmation-modal>

<app-tool-ersa-confirmation-modal
    (clickSelection)="onSelectionErsaBay($event)">
</app-tool-ersa-confirmation-modal>
<app-logout-modal
    title="{{ 'lineSetter.tool-returns.pages.logoutModal.title' | translate }}"
    infoMessage="{{ 'lineSetter.tool-returns.pages.logoutModal.infoMessage' | translate }}"
    [timer]="badgeLogoutCountdownSeconds">
</app-logout-modal>

<ng-template #loadingAnimation>
    <app-loading-spinner class="loader"></app-loading-spinner>
</ng-template>
